(function() {
  const pollingTimer = setInterval(function() {
    const formEmbed = document.querySelector('shopify-forms-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      const formContainer = formEmbed.shadowRoot.querySelector('section[data-sizing="form-wrapper"]');

      if (formContainer) {
        formContainer.style.setProperty('background-color', '#F0EDE7', 'important');
        formContainer.style.setProperty('--col-size', 'unset', 'important');
        formContainer.style.setProperty('max-width', 'unset', 'important');

        const inputElements = formContainer.querySelectorAll(
          'input, textarea, select, [aria-controls="country-selector-dropdown"], [role="combobox"], [role="listbox"], .shopify-forms__field__input, .shopify-forms__input'
        );

        inputElements.forEach((inputElement) => {
          inputElement.style.setProperty('background-color', '#D7C59F', 'important');
          inputElement.style.setProperty('background', '#D7C59F', 'important');
          inputElement.style.setProperty('color', '#F0EDE7', 'important');
        });

        const customInputWrappers = formContainer.querySelectorAll('[class*="input"], [class*="field"]');
        customInputWrappers.forEach((wrapper) => {
          const input = wrapper.querySelector('input, textarea, select');
          if (input) {
            input.style.setProperty('background-color', '#D7C59F', 'important');
            input.style.setProperty('background', '#D7C59F', 'important');
            input.style.setProperty('color', '#F0EDE7', 'important');
          }
        });

        const styleElement = document.createElement('style');
        styleElement.textContent = `
          input::placeholder,
          textarea::placeholder,
          select::placeholder,
          .shopify-forms__field__input::placeholder,
          .shopify-forms__input::placeholder {
            color: #F0EDE7 !important;
            -webkit-text-fill-color: #F0EDE7 !important;
            opacity: 1 !important;
          }

          /* Shopify Forms usa label flutuante em vez de placeholder em alguns campos */
          label[class*="formInputFieldLabel"],
          [id^="label-"] {
            color: #F0EDE7 !important;
            -webkit-text-fill-color: #F0EDE7 !important;
            opacity: 1 !important;
          }
        `;
        formContainer.appendChild(styleElement);

        const floatingLabelElements = formContainer.querySelectorAll('label[class*="formInputFieldLabel"], [id^="label-"]');
        floatingLabelElements.forEach((labelElement) => {
          labelElement.style.setProperty('color', '#F0EDE7', 'important');
          labelElement.style.setProperty('-webkit-text-fill-color', '#F0EDE7', 'important');
          labelElement.style.setProperty('opacity', '1', 'important');
        });

        const popupSection = formContainer.querySelector('section');
        if (popupSection) {
          popupSection.style.setProperty('font-family', "'Seiva Display'", 'important');
          popupSection.style.setProperty('font-size', '30px', 'important');
          popupSection.style.setProperty('letter-spacing', '6px', 'important');
          popupSection.style.setProperty('font-weight', '400', 'important');
          popupSection.style.setProperty('text-transform', 'uppercase', 'important');
          popupSection.style.setProperty('margin-bottom', '40px', 'important');
        }

        const popupTitles = formContainer.querySelectorAll('h2');
        popupTitles.forEach((title) => {
          title.style.setProperty('font-family', "'Seiva Display'", 'important');
          title.style.setProperty('font-size', '30px', 'important');
          title.style.setProperty('letter-spacing', '6px', 'important');
          title.style.setProperty('font-weight', '400', 'important');
          title.style.setProperty('text-transform', 'uppercase', 'important');
          title.style.setProperty('margin-bottom', '40px', 'important');
        });

        const popupParagraphs = formContainer.querySelectorAll('p');
        popupParagraphs.forEach((paragraph) => {
          paragraph.style.setProperty('font-family', "'Seiva Display'", 'important');
          paragraph.style.setProperty('font-size', '15px', 'important');
          paragraph.style.setProperty('font-weight', '300', 'important');
          paragraph.style.setProperty('letter-spacing', '1.5px', 'important');
          paragraph.style.setProperty('line-height', '1.8', 'important');
          paragraph.style.setProperty('display', 'block', 'important');
          paragraph.style.setProperty('max-width', '400px', 'important');
          paragraph.style.setProperty('margin', '0 auto', 'important');
        });

        const dateBirthdayAndFieldsetElements = formContainer.querySelectorAll(
          '[data-testid="date-birthday"] div, fieldset legend, fieldset label span, fieldset > span'
        );

        dateBirthdayAndFieldsetElements.forEach((element) => {
          element.style.setProperty('font-family', "'Montserrat', 'Helvetica', sans-serif", 'important');
          element.style.setProperty('font-size', '12px', 'important');
          element.style.setProperty('font-weight', '300', 'important');
          element.style.setProperty('letter-spacing', '1.5px', 'important');
          element.style.setProperty('line-height', '1.8', 'important');
        });

        const submitButtons = formContainer.querySelectorAll('[data-testid="btn-form-submit"]');
        submitButtons.forEach((button) => {
          button.style.setProperty('border-radius', '2px');
          button.style.setProperty('font-size', '15px');
          button.style.setProperty('font-weight', '400');
        });

        const preferredStoreDropdownTrigger = formContainer.querySelector(
          '[aria-controls="custom#loja_de_preferncia-selector-dropdown"]'
        );

        if (preferredStoreDropdownTrigger) {
          const previousSiblingElement = preferredStoreDropdownTrigger.previousElementSibling;
          preferredStoreDropdownTrigger.style.setProperty('background-color', '#D7C59F', 'important');

          const firstSpanInsideButton = preferredStoreDropdownTrigger.querySelector('span');
          if (firstSpanInsideButton) {
            firstSpanInsideButton.style.setProperty('color', '#F0EDE7', 'important');
            firstSpanInsideButton.style.setProperty('-webkit-text-fill-color', '#F0EDE7', 'important');
            firstSpanInsideButton.style.setProperty('opacity', '1', 'important');
          }

          if (previousSiblingElement && previousSiblingElement.tagName === 'P') {
            previousSiblingElement.style.setProperty('font-family', 'Montserrat, Helvetica, sans-serif', 'important');
            previousSiblingElement.style.setProperty('font-size', '12px', 'important');
            previousSiblingElement.style.setProperty('font-weight', '300', 'important');
            previousSiblingElement.style.setProperty('letter-spacing', '1.5px', 'important');
            previousSiblingElement.style.setProperty('line-height', '1.8', 'important');
            previousSiblingElement.style.setProperty('margin', 'unset', 'important');
          }
        }

        clearInterval(pollingTimer);
      }
    }
  }, 500);
})();